import { styled } from "@linaria/react";
import { styleTokens } from "@ideally-ltd/design-tokens";
import { PTooltipWrapped } from "components/prime/PTooltip/PTooltip";

const TooltipWrapped = styled(PTooltipWrapped)`
  font-size: 1.1875rem;
`;
const InfoTooltip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  :not(:hover) {
    color: ${styleTokens.inputtext.placeholder} !important;
  }
  i {
    max-width: 17px;
    max-height: 17px;
    font-size: 17px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
`;

export const InfoTooltipStyle = { InfoTooltip, TooltipWrapped };
